// start:ng42.barrel
import './payments.constants';
import './payments.service';
import './components';
// end:ng42.barrel

